import { isFuzzyMatch } from '@azuken/pokemon-go-shared/fuzzy-match';

const FUZZY_MATCH_THRESHOLD = 70;

export const normalizeSearchText = (value: string): string =>
  value
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

export const matchesSearchTerm = (target: string, term: string): boolean => {
  const normalizedTarget = normalizeSearchText(target);
  const words = normalizeSearchText(term).split(' ').filter(Boolean);

  return words.every((word) => normalizedTarget.includes(word));
};

export const fuzzyMatchesSearchTerm = (target: string, term: string): boolean => {
  const normalizedTarget = normalizeSearchText(target);
  const targetWords = normalizedTarget.split(' ').filter(Boolean);
  const words = normalizeSearchText(term).split(' ').filter(Boolean);

  return words.every(
    (word) =>
      normalizedTarget.includes(word) ||
      targetWords.some((targetWord) => isFuzzyMatch([targetWord], word, FUZZY_MATCH_THRESHOLD)),
  );
};
